import { render, staticRenderFns } from "./orderCgApproveSh.vue?vue&type=template&id=63dd382c&scoped=true"
import script from "./orderCgApproveSh.vue?vue&type=script&lang=js"
export * from "./orderCgApproveSh.vue?vue&type=script&lang=js"
import style0 from "./orderCgApproveSh.vue?vue&type=style&index=0&id=63dd382c&prod&scoped=true&lang=css"
import style1 from "./orderCgApproveSh.vue?vue&type=style&index=1&id=63dd382c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd382c",
  null
  
)

export default component.exports